"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalAutoDiscounts = void 0;
var PersonalAutoDiscounts;
(function (PersonalAutoDiscounts) {
    PersonalAutoDiscounts["ANTI_THEFT"] = "Anti-Theft";
    PersonalAutoDiscounts["AUTO_SAFETY_EQUIPMENT"] = "Auto Safety Equipment";
    PersonalAutoDiscounts["TRACKING_DEVICE"] = "Driving Behavior Tracking Device";
    PersonalAutoDiscounts["ELECTRIC_VEHICLE"] = "Electric Vehicle";
    PersonalAutoDiscounts["GOOD_DRIVER"] = "Good Driver";
    PersonalAutoDiscounts["HOMEOWNER"] = "Homeowner";
    PersonalAutoDiscounts["LOW_MILEAGE"] = "Low Mileage";
    PersonalAutoDiscounts["MULTI_VEHICLE"] = "Multi-Vehicle";
    PersonalAutoDiscounts["NEW_CAR"] = "New Car";
    PersonalAutoDiscounts["PROFESSIONAL"] = "Professional";
    PersonalAutoDiscounts["SAFETY_COURSE"] = "Safety Course";
    PersonalAutoDiscounts["NO_VIOLATIONS"] = "Violation Free";
    PersonalAutoDiscounts["COMBINED_GOOD_DRIVER_SAFETY_COURSE"] = "Steer Clear Discount";
})(PersonalAutoDiscounts = exports.PersonalAutoDiscounts || (exports.PersonalAutoDiscounts = {}));
